import React, { useEffect, useRef } from 'react';
import { Download, FileText, Image as ImageIcon, X } from 'lucide-react';
import ModalPortal from '../Modal/ModalPortal';

export default function FileViewer({ file, type, url, loading, error, downloading, onDownload, onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <ModalPortal>
      <div className="file-viewer-overlay" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
        <section className="file-viewer" role="dialog" aria-modal="true" aria-label={`Preview ${file.name || 'file'}`}>
          <header className="file-viewer-header">
            <div className="file-viewer-title">
              {type === 'pdf' ? <FileText size={18} /> : <ImageIcon size={18} />}
              <span title={file.name}>{file.name || 'File preview'}</span>
            </div>
            <div className="file-viewer-actions">
              <button type="button" className="btn btn-ghost btn-sm" onClick={onDownload} disabled={downloading} aria-label="Download file">
                <Download size={15} /> <span className="file-viewer-download-label">{downloading ? 'Preparing…' : 'Download'}</span>
              </button>
              <button ref={closeRef} type="button" className="file-viewer-close" onClick={onClose} aria-label="Close preview" title="Close preview">
                <X size={19} />
              </button>
            </div>
          </header>

          <div className={`file-viewer-content file-viewer-content-${type}`}>
            {loading ? (
              <div className="file-viewer-state"><span className="spinner" /><span>Loading preview…</span></div>
            ) : error ? (
              <div className="file-viewer-state file-viewer-error">
                <FileText size={34} />
                <strong>Preview unavailable</strong>
                <span>{error}</span>
                <button type="button" className="btn btn-primary btn-sm" onClick={onDownload}>Download file</button>
              </div>
            ) : type === 'pdf' ? (
              <iframe src={url} title={file.name || 'PDF preview'} />
            ) : (
              <img src={url} alt={file.name || 'Image preview'} />
            )}
          </div>
        </section>
      </div>
    </ModalPortal>
  );
}
